import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";

export const useProjectConnectionGroupQueries = () => {
  const api = useApi();

  return {
    list: (connectionId: string, params: { Offset: number; Limit: number }) =>
      queryOptions({
        queryKey: QUERY_KEYS.PROJECT_CONNECTION_GROUPS_LIST(connectionId, params),
        queryFn: () => api.getProjectConnectionsGroupsV1(connectionId, params),
        select: commonAPIDataSelector,
      }),
    details: (groupId: string, connectionId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.PROJECT_CONNECTION_GROUP_DETAILS(groupId),
        queryFn: () => api.getProjectConnectionsGroupsDetailsV1(groupId, connectionId),
        select: commonAPIDataSelector,
      }),
  };
};
